import '../../blocks/services/scripts.js';
import '../../blocks/hero/scripts.js';
import '../../blocks/staff/scripts.js';
import '../../blocks/posts/scripts.js';
import '../../blocks/table/scripts.js';
import '../../blocks/boxes/scripts.js';
import '../../blocks/faq/scripts.js';
import './img-swapper.js';

(function ($) {
    $(document).ready(function () {
        // Mobile menu functionality
        initMobileMenu();
    });

    // Mobile menu initialization
    function initMobileMenu() {
        const $mobileToggle = $('.mobile-menu-toggle');
        const $mobileContent = $('.mobile-menu-content');
        const $mobileClose = $('.mobile-menu-close');
        const $body = $('body');
        const $mobileMain = $('.mobile-menu-main');
        const $mobileSubmenus = $('.mobile-submenus');

        // Toggle mobile menu
        $mobileToggle.on('click', function() {
            $(this).toggleClass('is-active');
            $mobileContent.toggleClass('is-open');
            $body.toggleClass('overflow-hidden');
            
            // Reset menu state when opening
            if ($mobileContent.hasClass('is-open')) {
                resetMobileMenu();
            }
        });

        // Close mobile menu
        $mobileClose.on('click', function() {
            closeMobileMenu();
        });

        // Handle submenu navigation
        $('.mobile-menu-parent').on('click', function() {
            const submenuType = $(this).closest('.mobile-menu-item').data('submenu');
            showSubmenu(submenuType);
        });

        // Back from submenu to main menu
        $('.mobile-submenu-back, .mobile-submenu-back-main').on('click', function() {
            backToMainMenu();
        });

        // Close mobile menu when clicking outside or on menu links
        $mobileContent.on('click', function(e) {
            if (e.target === this) {
                closeMobileMenu();
            }
        });

        // Close mobile menu when clicking on submenu links
        $('.mobile-submenu-item a').on('click', function() {
            closeMobileMenu();
        });

        // Handle window resize
        $(window).on('resize', function() {
            if ($(window).width() >= 1280) { // xl breakpoint
                closeMobileMenu();
            }
        });

        function showSubmenu(submenuType) {
            $mobileMain.addClass('slide-left');
            $mobileSubmenus.addClass('show-submenu');
            $(`.mobile-submenu-page[data-menu="${submenuType}"]`).addClass('active');
        }

        function backToMainMenu() {
            $mobileMain.removeClass('slide-left');
            $mobileSubmenus.removeClass('show-submenu');
            $('.mobile-submenu-page').removeClass('active');
        }

        function resetMobileMenu() {
            backToMainMenu();
        }

        function closeMobileMenu() {
            $mobileToggle.removeClass('is-active');
            $mobileContent.removeClass('is-open');
            $body.removeClass('overflow-hidden');
            resetMobileMenu();
        }
    }
    $(window).on('load', function () {
        //$('.preloader').addClass('preloader--hidden');
    });

    $(window).resize(function () {

    });
    $(window).on('scroll', function () {
        var scroll = $(window).scrollTop();
        if (scroll >= 100) {
            $(".header").addClass("header--scrolling");
  
        } else {
            $(".header").removeClass("header--scrolling");
         
        }
    });
}(jQuery));